import { jwtDecode } from 'jwt-decode';

export const CUSTOMER_KEY = 'customer';

const customerIsBroker = () => {
  const customer = getCurrentUserBySessionKey(CUSTOMER_KEY);
  if (customer) {
    const { broker } = customer;
    return broker;
  }
  return false;
};

export const getCurrentUserBySessionKey = (sessionKey: string) => {
  return JSON.parse(String(localStorage.getItem(sessionKey)));
};

export const getTokenCurrentCustomer = () => {
  return getCurrentUserBySessionKey(CUSTOMER_KEY)?.token;
};
export const getTokenUserCrm = () => {
  return getCurrentUserBySessionKey('CRM')?.token;
};

export const getTokenSihmma = () => {
  return getCurrentUserBySessionKey(CUSTOMER_KEY)?.control;
};

export const getTokenbyKey = (key: string) => {
  return getCurrentUserBySessionKey(key)?.token;
};

type JwtPayload = {
  [key: string]: any;
  exp?: number;
  iat?: number;
};

export const decodeJwt = (token: string): JwtPayload | null => {
  if (!token) {
    console.error('Token is required');
    return null;
  }

  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.error('Invalid JWT token format');
      return null;
    }

    const payloadBase64 = parts[1];
    const payloadJson = atob(payloadBase64);
    const payload: JwtPayload = JSON.parse(payloadJson);

    return payload;
  } catch (error) {
    console.error('Failed to decode JWT token:', error);
    return null;
  }
};

export const isAnExpiredToken = (exp?: number) => {
  if (!exp) {
    return true;
  }
  const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
  return currentTime > exp;
};

export const customerIsLogged = () => {
  const customer = getCurrentUserBySessionKey(CUSTOMER_KEY);
  const decodedPayload = customer?.token ? decodeJwt(customer?.token) : null;
  return decodedPayload ? (isAnExpiredToken(decodedPayload?.exp) ? false : true) : false;
};

export const userCrmIsLogged = () => {
  const user = getCurrentUserBySessionKey('CRM');

  if (!user || !user.token) {
    return false; // User is not logged in if there's no user or token
  }

  try {
    // Decode the token to extract the expiration time
    const decodedToken: { exp: number } = jwtDecode(user.token);
    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds

    // Check if the token is still valid
    return decodedToken.exp > currentTime;
  } catch (error) {
    console.error('Error decoding token:', error);
    return false; // If there's an error decoding the token, consider the user not logged in
  }
};
export const clearUserCrmLogged = () => {
  return localStorage.removeItem('CRM');
};

export const updateCurrentCustomer = (customerToUpdate: any) => {
  const customer = getCurrentUserBySessionKey(CUSTOMER_KEY);
  const customerUpdated = { ...customer, ...customerToUpdate };
  localStorage.setItem(CUSTOMER_KEY, JSON.stringify(customerUpdated));
};

export default customerIsBroker;
